import React from 'react';
import styles from '../giceliluna/giceliluna.module.scss';
import Perfil from './src/perfil.png';
import LinkPersonalizado3 from '../../components/LinkPersonalizado3/linkPersonalizado3.tsx';

const Giceliluna: React.FC = () => {

    return (
        <div className={styles.giceliluna}>
            <div className={styles["body-thunder"]} >
                <div className={styles["background-thunder"]}></div>
                <div className={`${styles["container-thunder"]}`} >
                    <div className={styles["img-wrapper"]}>
                        <img
                            className={styles["img-perfil"]}
                            src={Perfil}
                            alt="Profile Picture"
                        />
                    </div>
                    <h1 className="mt-4 mb-0">GICELI LUNA</h1>
                    <h1 className="mb-2">IM<span className={styles.fontPadrao}>Ó</span>VEIS</h1>
                    <p className="mb-0">Advogada por formação</p>
                    <p className="mb-6">Corretora e Perita em Imóveis por paixão</p>
                    <div className={styles.links}>
                        <LinkPersonalizado3
                            href="https://wa.me/5517991019339?text=Olá! Tenho interesse em um imóvel e gostaria de mais informações. Você pode me ajudar?"
                            title="Whatsapp"
                        />
                        <LinkPersonalizado3
                            href="https://www.instagram.com/giceliluna?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            title="Instagram"
                        />
                        <LinkPersonalizado3
                            href="https://maps.app.goo.gl/3eT2exM66xAhh5Yy5"
                            title="Localização"
                        />
                    </div>
                    <div>
                        <img width={250} src={require("./src/footer.png")} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Giceliluna;
